import React from 'react';

/** Stroke icons matching html-preview/xtram_dashboard.html module sprites.
 *  Color comes from `currentColor` (set via the card accent CSS variable). */

const svgProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

/** Briefcase — Accounting Management */
export function AccountingModuleIcon(props) {
  return (
    <svg {...svgProps} {...props}>
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M9 7V4h6v3M3 12h18" />
    </svg>
  );
}

/** Shopping cart — Sales */
export function SalesModuleIcon(props) {
  return (
    <svg {...svgProps} {...props}>
      <path d="M3 4h2l2 11h10l2-8H6" />
      <circle cx="9" cy="19" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="17" cy="19" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

/** Archive box — Archive */
export function ArchiveModuleIcon(props) {
  return (
    <svg {...svgProps} {...props}>
      <path d="M4 8h16v12H4zM3 4h18v4H3zM9 12h6" />
    </svg>
  );
}

/** User silhouette — CRM */
export function CrmModuleIcon(props) {
  return (
    <svg {...svgProps} {...props}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </svg>
  );
}

/** Car — Vehicle Management / Garage */
export function VehicleModuleIcon(props) {
  return (
    <svg {...svgProps} {...props}>
      <path d="M5 17h14l-1-7-2-4H8L6 10l-1 7Z" />
      <circle cx="8" cy="17" r="2" />
      <circle cx="16" cy="17" r="2" />
    </svg>
  );
}

/** Bar chart — Reports (reference i-chart) */
export function ReportsModuleIcon(props) {
  return (
    <svg {...svgProps} {...props}>
      <path d="M5 20V10M12 20V4M19 20v-7" />
    </svg>
  );
}

/** Gear — Settings (reference i-settings, simplified) */
export function SettingsModuleIcon(props) {
  return (
    <svg {...svgProps} {...props}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.4-2.4 1a8 8 0 0 0-1.7-1L14.5 3h-5l-.4 3.1a8 8 0 0 0-1.7 1l-2.4-1-2 3.4L5 11a7 7 0 0 0 0 2l-2 1.5 2 3.4 2.4-1a8 8 0 0 0 1.7 1l.4 3.1h5l.4-3.1a8 8 0 0 0 1.7-1l2.4 1 2-3.4L19 13a7 7 0 0 0 .1-1Z" />
    </svg>
  );
}

/** Chain link — Matching / bank matching (reference i-link / expenses) */
export function MatchingModuleIcon(props) {
  return (
    <svg {...svgProps} {...props}>
      <path d="m10 13 4-4M8 17H6a4 4 0 1 1 0-8h3M16 7h2a4 4 0 1 1 0 8h-3" />
    </svg>
  );
}
